import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// Logical area: ModalSaving General Strings
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ui.ModalSaving.';

  public static readonly saving = `${Id.prefix}saving`;
  public static readonly pleaseWait = `${Id.prefix}pleaseWait`;
}

export class LangModalSaving {
  private constructor() {}

  public static saving(): string {
    return interpolate(Id.saving);
  }
  public static pleaseWait(): string {
    return interpolate(Id.pleaseWait);
  }
}

export class ModalSavingModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // General
    register.add(Id.saving, 'Saving', 'Saving dialog title');
    register.add(Id.pleaseWait, 'please wait while we update the data', 'Please wait message for saving');
  }
}
